import { createContext } from "react";

import type { SavedInputsContextValue } from "./SavedInputsContextValue";

export const SavedInputsContext = createContext<SavedInputsContextValue | null>(null);

SavedInputsContext.displayName = "SavedInputsContext";
